export default __webpack_public_path__ + "static/media/icon-eletricista.953a39fe.svg";